const link = {
  underline: "none",
  color: "inherit",
};

export default link;
